import { useMutation, useQueryClient } from 'react-query';

import { createObjectDoc as create } from 'api/objectDocs/createObjectDoc';

const usePostObjectDoc = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: createObjectDoc,
    isLoading,
  } = useMutation(create, {
    onSuccess: () => {
      queryClient.invalidateQueries(['useGetObjectDocs', 'ObjectDocsDetailPage']);
    },
  });

  return {
    isSuccess,
    createObjectDoc,
    isLoading,
  };
};

export default usePostObjectDoc;
